import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { auth as authModule } from 'redux/modules'
import { compose } from 'redux'
import { TEAMS_ROUTE } from '../../constants/routes'

const FirstEntryRouterContainer = ({
  history,
  seasons,
  fetchLoginUserDetails,
  authUser,
}) => {
  const firstSeason = seasons.items.find(Boolean)

  const d = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  )

  const firstActiveSeason = seasons.items
    .filter(
      (season) =>
        d >= new Date(season.start_date) && d <= new Date(season.end_date)
    )
    .find(Boolean)

  if (!firstActiveSeason && !firstSeason) {
    return <div />
  }

  React.useEffect(() => {
    if (
      !authUser ||
      !authUser.first_name ||
      !authUser.tz ||
      !authUser.datetime_format
    ) {
      fetchLoginUserDetails()
    }

    history.push(TEAMS_ROUTE)
  }, [])

  return null
}

FirstEntryRouterContainer.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  seasons: PropTypes.shape().isRequired,
  fetchLoginUserDetails: PropTypes.func.isRequired,
  authUser: PropTypes.shape().isRequired,
}

export default compose(
  withRouter,
  connect(
    ({ seasons, auth }) => ({
      seasons,
      authUser: auth.user,
    }),
    {
      fetchLoginUserDetails: authModule.fetchUser,
    }
  )
)(FirstEntryRouterContainer)
